<template>
	<page>
		<module title="基本信息" height="auto">
			<c-detail >
				<c-detail-item label="订单类型" >
					<span v-if="orderDetail.order_type==1" style="color:lightsalmon">代理订单</span>
					<span v-else style="color:lightseagreen">销售订单</span>
				</c-detail-item>
				<c-detail-item label="业务单号" >
					{{orderDetail.order_number}}
				</c-detail-item>
				<c-detail-item label="下单用户" >
					{{orderDetail.nick_name}}【{{orderDetail.user_manage_mobilephone}}】
				</c-detail-item>
				<c-detail-item label="下单用户等级" >
					{{orderDetail.level_name}}
				</c-detail-item>
				<c-detail-item label="下单时间" >
					{{orderDetail.create_date}}
				</c-detail-item>
				<c-detail-item label="支付时间" >
					{{orderDetail.payment_date}}
				</c-detail-item>
				<c-detail-item label="订单总额" >
					<span v-if="orderDetail.order_type == 1 && orderDetail.payment_money">
						￥{{parseFloat(parseFloat(orderDetail.payment_money).toFixed(2))}}
					</span>
					<span v-if="orderDetail.order_type == 2 && orderDetail.product_money">
						￥{{parseFloat(parseFloat(orderDetail.product_money).toFixed(2))}}
					</span>
				</c-detail-item>
				<c-detail-item label="已支付金额" v-if="orderDetail.order_type == 2">
					￥{{parseFloat(parseFloat(orderDetail.payment_money).toFixed(2))}}
				</c-detail-item>
				<c-detail-item label="待支付尾款" v-if="orderDetail.order_type == 2">
					<span v-if="(orderDetail.product_money-orderDetail.payment_money) > 0" style="color:red">
						¥{{parseFloat(parseFloat(orderDetail.product_money-orderDetail.payment_money).toFixed(2))}}
					</span>
					<span v-else>-</span>
				</c-detail-item>
			</c-detail>
		</module>
		
		<module title="清分信息">
			<div style="padding: 30px 30px 40px;">
				<c-table v-model="rewardRecordList" height="auto" :paging="false" border>
					<c-table-column
						label="结算流水号"
						name="record_number"
						width="120"
					></c-table-column>
					
					<c-table-column
						label="结算类型 "
						name="reward_type"
						width="100"
					>
						<template v-slot="row">
							{{rewardTypeName[row.data.reward_type]}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="结算对象 "
						name="user_type"
						width="150"
					>
						<template v-slot="row">
							<span v-if="row.data.user_type==1"><span style="color:darkgreen">（代理）</span>{{row.data.reward_nick_name}}</span>
							<span v-if="row.data.user_type==2"><span style="color:#2348d0">（商家）</span>{{row.data.company_name}}</span>
							<span v-if="row.data.user_type==3" style="color:red">（平台）</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="结算占比"
						name="record_ratio"
						width="90"
					>
						<template v-slot="row">
						    {{parseFloat((parseFloat(row.data.record_ratio)*100).toFixed(2))}}%
						</template>
					</c-table-column>
					
					<c-table-column
						label="可结算金额"
						name="estimated_record_money"
						width="90"
					>
						<template v-slot="row">
						    <span style="color:blue;">¥{{parseFloat(parseFloat(row.data.estimated_record_money).toFixed(2))}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="预计最终结算金额"
						name="original_record_money"
						width="130"
					>
						<template v-slot="row">
							<span style="color:gray;">¥{{parseFloat(parseFloat(row.data.original_record_money).toFixed(2))}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="已结算金额"
						name="record_money"
						width="100"
					>
						<template v-slot="row">
						    <span v-if="row.data.state == 2" style="color:green;">
								¥{{parseFloat(parseFloat(row.data.record_money).toFixed(2))}}
							</span>
							<span v-else>-</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="结算状态"
						name="state"
						width="75"
					>
						<template v-slot="{data}">
					        <span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
					        <span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
							<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="结算说明"
						name="remark"
						width="270"
					></c-table-column>
					
					<c-table-column
						label="生成时间"
						name="create_date"
						width="140"
					></c-table-column>
					
					<c-table-column
						label="最近更新时间"
						name="update_date"
						width="140"
					></c-table-column>
					
					<c-table-column
						label="取消时间"
						name="cancel_date"
						width="140"
					>
						<template v-slot="{data}">
						    <span v-if="data.cancel_date && data.state==0" style="color:darkgray">{{data.cancel_date}}</span>
						    <span v-else>-</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="取消原因"
						name="reject_reason"
						width="140"
					>
						<template v-slot="{data}">
						    <span v-if="data.reject_reason && data.state==0" style="color:darkgray">{{data.reject_reason}}</span>
						    <span v-else>-</span>
						</template>
					</c-table-column>

					<c-table-column
						type="button"
						fixed="right"
						label="操作"
						width="100"
					>
						<template v-slot="{data}">
							<c-table-button @click="rejected(data)" v-if="data.state == 1 ">取消结算</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</div>
		</module>
		
		<c-dialog ref="rejectedReason" title="取消原因" width="400" @resolve="rejectedHandle">
			<div class="rejected-eason">
				<textarea v-model="rejectedReason" placeholder="请输入取消结算原因..."></textarea>
			</div>
		</c-dialog>


	</page>
</template>

<script>
	export default {
		name: 'reward_record_detail',
		props: {
			orderNumber: String
		},
		data() {
			return {
				orderTypeName: {
				  1: '代理订单',
				  2: '销售订单'
				},
				transStateName: {
					0: '取消结算',
					1: '待结算',
					2: '已结算'
				},
				rewardTypeName:{
					2: '直推奖励',
					3: '间推奖励',
					201: '爆款代理费',
					202: '专业代理费',
					203: '市代代理费',
					204: '省代代理费',
					205: '业务员代理费',
					206: '平台服务费',
					207: '商家货款'
				},
				orderDetail: {},
				rewardRecordList: [],
				rejectedReason: ''
			}
		},
		watch:{//ID变更刷新页面
			orderNumber(){
				this.detail();
			}
		},
		mounted() {
			this.detail();
		},
		computed: {

		},
		methods: {
			detail() {
				this.request({
					url: '/reward/record/detail',
					data: {order_number: this.orderNumber},
					loading: true,
					success: data => {
						this.orderDetail = data.order_info;
						this.rewardRecordList = data.reward_records;
					}
				});
			},
			//驳回弹框
			rejected(data) {
				this.t_data = data;
				this.$refs.rejectedReason.open();
			},
			//取消驳回提交
			rejectedHandle(stop){

				if (!this.rejectedReason.trim()) {
					this.$message({
						text: '请填写取消结算原因'
					});
					stop();
					return;
				}
				this.request({
					url: '/reward/record/cancel',
					data: {id:this.t_data.id,reject_reason:this.rejectedReason.trim()},
					loading: true,
					success: data => {
						this.$message({
							text: '取消结算成功',
							icon: 'success'
						});
						this.t_data.state = 0;
						this.t_data.reject_reason = this.rejectedReason.trim();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.rejected-eason {
		padding: 20px;

		textarea {
			box-sizing: border-box;
			width: 100%;
			height: 120px;
			border: none;
			padding: 10px 14px;
			line-height: 20px;
			background: #FAFAFA;
			resize: none;
		}
	}
  a {
    color: #003DD9;
  }
</style>